import { render, staticRenderFns } from "./directExamMemS.vue?vue&type=template&id=6aa70638&scoped=true&"
import script from "./directExamMemS.vue?vue&type=script&lang=js&"
export * from "./directExamMemS.vue?vue&type=script&lang=js&"
import style0 from "./directExamMemS.vue?vue&type=style&index=0&id=6aa70638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa70638",
  null
  
)

export default component.exports